/* esm.sh - applesauce-loaders@5.1.0/dist/helpers/loaders */
export * from "/*applesauce-loaders@5.1.0/esnext/dist/helpers/loaders.mjs";
